import * as algoliasearch from 'algoliasearch';
import { HTTP } from '../../../assets/js/axiosConfig';
import { firestoreDB } from '../../../assets/js/firebase';
// Initialise algolia

const client = algoliasearch(process.env.ALGOLIA_APP_ID, process.env.ALGOLIA_SEARCH_KEY);
const productIndex = client.initIndex(`${process.env.ENV_SHORTNAME}_products`);
const previewProductBlocks = {
  patents: {
    name: {
      valueName: 'name',
    },
    number: {
      valueName: 'number',
    },
    claim_on_website: {
      valueName: 'claim_website',
    },
    claim_on_pack: {
      valueName: 'claim_pack',
    },
    ingredients: {
      valueName: 'ingredients',
      idName: 'ingredient_id',
    },
    patentRoles: {
      valueName: 'roles',
      idName: 'role_id',
    },
  },
  ingredients: {
    name: {
      valueName: 'name',
    },
    ingredient_dosage_product_preview: {
      valueName: 'dosage',
      idName: 'ingredient_dosage',
    },
    ingredient_claimed_on_website: {
      valueName: 'claim_website',
      fallback: 'is_claimed_on_website',
    },
    ingredient_claimed_on_pack: {
      valueName: 'claim_pack',
      fallback: 'is_claimed_pack',
    },
    related_inci: {
      valueName: 'related_inci',
    },
  },
  roles: {
    name: {
      valueName: 'role_id',
      resource: 'roles',
    },
    is_patent: {
      valueName: 'is_patent',
    },
    mode_action: {
      valueName: 'mode_action_id',
      resource: 'mode_actions',
    },
    description: {
      valueName: 'description',
      resource: 'roles',
      idName: 'role_id',
    },
    ingredient: {
      valueName: 'ingredient_id',
      resource: 'ingredients',
    },
    dosage: {
      valueName: 'dosage',
    },
    related_inci: {
      valueName: 'related_inci',
    },
  },
  segmentations: {
    theme_id: {
      valueName: 'theme_id',
      resource: 'themes',
    },
    segmentation_parent: {
      valueName: 'segmentation_parent',
      resource: 'segmentations',
      customKey: 'segmentation_id',
    },
    child_segmentation: {
      valueName: 'name',
    },
    verbatim_consos: {
      valueName: 'verbatim_consos',
    },
  },
  themes: {
    name: {},
  },
};
const state = {
  productIndex,
  activeIndex: null,
  ingredients: [],
  patents: [],
  page: 1,
  results: readJSON('products'),
  query: {
    limit: 50,
    page: 0,
    totalPages: 0,
    totalRecords: 0,
    facets: readJSON('productFacetsChange'),
  },
  formData: null,
  formValue: null,
  facetFilters: [],
  keywords: '',
  segmentationNames: [],
  activeSegment: null,
  selectedSegments: [],
  defaultFacets: readJSON('defaultFacetsProducts'),
  queryURL: {},
  success: false,
  editingProduct: false,
  selectedProductIds: [],
  allSelected: false,
  lastSearch: readJSON('lastSearch'),
  previewURL: readJSON('lastQueryURL'),
  previewProductBlocks,
};

const mutations = {
  SET_ACTIVE_INDEX(state, index) {
    state.activeIndex = index;
  },
  GET_PRODUCT_INGREDIENTS(state, productId) {
    HTTP.get(`api/products/${productId}/ingredients`)
      .then((response) => {
        state.ingredients = response.data;
      })
      .catch((err) => state.ingredients = []);
  },
  GET_PRODUCT_PATENTS(state, productId) {
    const docRef = firestoreDB
      .collection(`${process.env.ENV_SHORTNAME}_products_patents`)
      .doc(productId)
      .collection('patents')
      .get()
      .then((querySnapshot) => {
        if (querySnapshot.docs) {
          state.patents = querySnapshot.docs.map((doc) => doc.data());
        }
      })
      .catch((error) => {
        console.error('Error : ', error);
      });
  },
  UPDATE_DATA_LIST(state, payload) {
    if (payload.action === 'delete') {
      state[payload.dataName].splice(payload.index, 1);
    } else if (payload.action === 'update') {
      state[payload.dataName][payload.index] = payload.data;
    } else {
      state[payload.dataName].push(payload.data);
    }
  },
  UPDATE_KEYWORD(state, value) {
    state.keywords = value;
  },
  UPDATE_FACET_FILTERS(state, value) {
    state.facetFilters = value;
  },
  SET_FORM_MODAL_DATA(state, value) {
    state.formData = value;
  },
  SET_FORM_VALUE(state, value) {
    state.formValue = value;
  },
  PRODUCT_SEGMENT_ACTION(state, data) {
    state.activeSegment = data.index;
  },
  UPDATE_SEGMENTS_NAMES(state, data) {
    if (data.action === 'reset') {
      state.segmentationNames = [];
    } else {
      state.segmentationNames.push(data);
    }
  },
  UPDATE_SELECTED_SEGMENTS(state, data) {
    if (data.action === 'add') {
      state.selectedSegments.push(data.value);
    } else if (data.action === 'delete') {
      state.selectedSegments.splice(data.index, 1);
    } else if (data.action === 'reset') {
      state.selectedSegments = [];
    }
  },
  SEARCH_FACETS(state, payload) {
    productIndex.searchForFacetValues({
      facetName: payload.data.name,
      facetQuery: payload.data.query,
      facetFilters: payload.filters,
    }, (err, { facetHits }) => {
      if (err) throw err;
      state.query.facets[payload.data.name] = formatFacetHit(facetHits, payload.data.name);
    });
  },
  SET_FILTER_QUERY(state, data) {
    if (data && Object.keys(data).length) {
      const obj = { ...state.queryURL, ...data };
      state.queryURL = obj;
    } else {
      state.queryURL = {};
    }
  },
  UPDATE_PRODUCT_LIST(state, payload) {
    if (payload && payload.index) {
      state.results.splice(payload.index, 1);
      storeJSON(state.results, 'products');
      state.results.totalRecords -= 1;
    } else if (payload && payload.data && payload.action === 'update') {
      state.results.map((product, index) => {
        if (product.productId === payload.data.product_id) {
          state.results[index] = payload.data;
        }
      });
      storeJSON(state.results, 'products');
    } else {
      state.results.push(payload.data);
    }
  },
  SET_PREVIEW_PRODUCT(state, id) {
    if (id) {
      productIndex.clearCache();
      productIndex.search(
        {
          query: id,
          hitsPerPage: 1,
        },
        (err, content) => {
          if (err) throw err;
          state.previewProduct = content.hits[0];
        },
      );
    } else {
      state.previewProduct = null;
    }
  },
  CLEAR_DATA(state, payload) {
    state[payload.name] = payload.value;
  },
  SET_EDITING_PRODUCT_STATUS(state, value) {
    state.editingProduct = value;
  },
  SET_SUCCESS_STATUS(state, value) {
    state.success = value;
  },
  SET_SELECTED_PRODUCTS(state, id) {
    if (id !== null) {
      const index = state.selectedProductIds.indexOf(id);
      index === -1 ? state.selectedProductIds.push(id) : state.selectedProductIds.splice(index, 1);
    } else {
      state.selectedProductIds = [];
    }
  },
  TOGGLE_ALL_SELECTED(state, value) {
    state.allSelected = value;
  },
  TOGGLE_CHECKBOXES(state, value) {
    // Uncheck all checkboxes
    $('.product_checkbox').prop('checked', value);
  },
  STORE_LAST_QUERY(state, query) {
    state.lastSearch = query;
    storeJSON(query, 'lastSearch');
  },
  STORE_LAST_QUERY_URL(state, query) {
    state.previewURL = query;
    storeJSON(query, 'lastQueryURL');
  },
};

const actions = {
  setActiveIndex({ commit }, index) {
    commit('SET_ACTIVE_INDEX', index);
  },
  getProductIngredients({ commit }, productId) {
    commit('GET_PRODUCT_INGREDIENTS', productId);
  },
  updateDataList({ getters, commit }, payload) {
    commit('UPDATE_DATA_LIST', payload);
  },
  getProductPatents({ commit }, productId) {
    commit('GET_PRODUCT_PATENTS', productId);
  },
  updateKeyword({ commit }, value) {
    commit('UPDATE_KEYWORD', value);
  },
  updateFacetFilters({ getters, commit }, value) {
    commit('UPDATE_FACET_FILTERS', value);
  },
  setFormModalData({ commit }, value) {
    commit('SET_FORM_MODAL_DATA', value);
  },
  setFormValue({ commit }, value) {
    commit('SET_FORM_VALUE', value);
  },
  productSegmentAction({ commit }, data) {
    commit('PRODUCT_SEGMENT_ACTION', data);
  },
  updateSegmentsNames({ commit }, data) {
    commit('UPDATE_SEGMENTS_NAMES', data);
  },
  updateSelectedSegments({ commit }, data) {
    commit('UPDATE_SELECTED_SEGMENTS', data);
  },
  searchFacets({ getters, commit }, data) {
    commit('SEARCH_FACETS', { filters: getters.searchFacetFilters(data.name), data });
  },
  setFilterQuery({ commit }, value) {
    commit('SET_FILTER_QUERY', value);
  },
  updateProductList({ commit }, payload) {
    commit('UPDATE_PRODUCT_LIST', payload);
  },
  setPreviewProduct({ commit }, id) {
    commit('SET_PREVIEW_PRODUCT', id);
  },
  clearData({ commit }, payload) {
    commit('CLEAR_DATA', payload);
  },
  setEditingProductStatus({ commit }, value) {
    commit('SET_EDITING_PRODUCT_STATUS', value);
  },
  setSuccessStatus({ commit }, value) {
    commit('SET_SUCCESS_STATUS', value);
  },
  setSelectedProducts({ commit }, value) {
    commit('SET_SELECTED_PRODUCTS', value);
  },
  toggleAllSelected({ commit }, value) {
    commit('TOGGLE_ALL_SELECTED', value);
  },
  toggleCheckBoxes({ commit }, value) {
    commit('TOGGLE_CHECKBOXES', value);
  },
  storeLastQuery({ commit }, query) {
    commit('STORE_LAST_QUERY', query);
  },
  storeLastQueryURL({ commit }, query) {
    commit('STORE_LAST_QUERY_URL', query);
  },
};

const getters = {
  productPatents: (state) => {
    const ids = [];
    state.patents.map((patent) => ids.push(patent.patent_id));
    return ids;
  },
  productIngredients: (state) => {
    const ids = [];
    state.ingredients.map((ingredient) => ids.push(ingredient.ingredient_id));
    return ids;
  },
  getLinkedData: (state, getters, rootState) => (id, resource, key) => rootState.crudData.cruds[resource].filter((item) => {
    if (item.hasOwnProperty(key)) {
      return item[key].indexOf(id) !== -1;
    }
  }),
  searchFacetFilters: (state) => (facet) => {
    const facets = state.facetFilters.filter((filt) => {
      const stringed = filt[0].split(':');
      return stringed.indexOf(facet) === -1;
    });
    return facets;
  },
  filterQueryURL: (state) => Object.values(state.queryURL) || [],
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

function storeJSON(data, name, source) {
  const stringJSON = JSON.stringify(data);
  localStorage.setItem(name, stringJSON);
}

function readJSON(name) {
  const parsedData = JSON.parse(localStorage.getItem(name));
  return parsedData || [];
}

function formatFacetHit(data, facet) {
  facet = {};
  data.map((val) => {
    facet[val.value] = val.count;
  });
  return facet;
}



// WEBPACK FOOTER //
// ./src/store/modules/products/index.js